<template>
  <div class="not-found">
    <h1>404 – Seite nicht gefunden</h1>
    <p>Die Seite, die Sie aufrufen wollten, existiert nicht oder wurde verschoben.</p>
    <router-link class="home-button" to="/">Zur {{ STRINGS.HOME }}</router-link>
  </div>
</template>

<script lang="ts">
import { Vue } from 'vue-class-component';
import { STRINGS } from '@/constants';

export default class NotFound extends Vue {
    STRINGS = STRINGS;
}
</script>

<style scoped>
.not-found {
  text-align: center;
  margin-top: 5rem;
  padding: 2rem;
  border-radius: 1rem;
}

h1 {
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #d32f2f;
}

p {
  font-size: 1.1rem;
  margin-bottom: 2rem;
}

.home-button {
  display: inline-block;
  background-color: var(--color-button-bg);
  color: var(--color-button-text);
  text-decoration: none;
  padding: 0.75rem 1.5rem;
  border-radius: 5px;
  font-weight: 500;
  border: 1px solid var(--color-border);
  transition: background-color 0.2s ease, color 0.2s ease, transform 0.1s ease;
}

.home-button:hover {
  background-color: var(--color-button-bg-hover);
}
</style>